import { useEffect, useState } from 'react';
import type { TripResponseArgs } from '@this/domain/trip/trip2';
import type { TripRealtimeInfo } from '../api';
import { fetchTripInfo } from '../api';

type PusherInfo = {
  key: string;
  channelPrefix: string;
};

export const useTrip = (tripId: string) => {
  const [trip, setTrip] = useState<TripResponseArgs | null>(null);
  const [pusherInfo, setPusherInfo] = useState<PusherInfo | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const tripData: TripRealtimeInfo = await fetchTripInfo(tripId);
        if (mounted) {
          setTrip(tripData.trip);
          setPusherInfo({
            key: tripData.pusherKey,
            channelPrefix: tripData.pusherChannelPrefix
          });
        }
      } catch (e) {
        if (mounted) {
          setError('旅程情報の取得に失敗しました。時間をおいて再度お試しください。');
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };
    load();
    return () => {
      mounted = false;
    };
  }, [tripId]);

  return { trip, pusherInfo, loading, error };
};
